document.addEventListener('DOMContentLoaded', () => {
    const deleteUserBtn = document.querySelector(".button--delete");
    const modal = document.querySelector(".delete-user-modal");

    if (!deleteUserBtn || !modal) {
        return;
    }

    const modalContainer = modal.querySelector(".delete-user-modal__container");
    const modalBackdrop = modal.querySelector(".delete-user-modal__backdrop");
    const closeBtn = modal.querySelector(".delete-user-modal__close");
    const deleteEventsBtn = modal.querySelector(".button--delete-events");
    const transferEventsBtn = modal.querySelector(".button--transfer-events");

    // Open modal
    function openModal() {
        modal.setAttribute('aria-hidden', 'false');
        modalBackdrop.classList.add('active');
        modalContainer.classList.add('active');
        document.body.classList.add('delete-user-modal-open');

        // Focus first interactive element
        setTimeout(() => {
            closeBtn.focus();
        }, 100);

        // Add event listeners
        document.addEventListener('keydown', handleKeyDown);
        modalContainer.addEventListener('keydown', handleFocusTrap);
    }

    // Close modal
    function closeModal() {
        modal.setAttribute('aria-hidden', 'true');
        modalBackdrop.classList.remove('active');
        modalContainer.classList.remove('active');
        document.body.classList.remove('delete-user-modal-open');

        // Remove event listeners
        document.removeEventListener('keydown', handleKeyDown);
        modalContainer.removeEventListener('keydown', handleFocusTrap);

        // Return focus to trigger button
        deleteUserBtn.focus();
    }

    // Handle keyboard events
    function handleKeyDown(event) {
        if (event.key === 'Escape' || event.keyCode === 27) {
            closeModal();
        }
    }

    // Focus trap
    function handleFocusTrap(event) {
        const focusable = modalContainer.querySelectorAll(
            'button:not([disabled]), a[href], input, select, textarea'
        );
        const firstFocusable = focusable[0];
        const lastFocusable = focusable[focusable.length - 1];
        const isTabPressed = event.key === 'Tab' || event.keyCode === 9;

        if (!isTabPressed) return;

        if (event.shiftKey) {
            if (document.activeElement === firstFocusable) {
                lastFocusable.focus();
                event.preventDefault();
            }
        } else {
            if (document.activeElement === lastFocusable) {
                firstFocusable.focus();
                event.preventDefault();
            }
        }
    }

    // Handle delete/transfer actions
    async function handleAction(action, button) {
        if (button.classList.contains('is-disabled') || button.classList.contains('is-loading')) {
            return;
        }

        // Lock button + show spinner
        button.classList.add('is-disabled', 'is-loading');

        // Force paint before fetch
        await new Promise(requestAnimationFrame);

        try {
            const transfer = action === 'transfer';
            const deleteUrl = `${window.location.origin}/event-manager/delete?transfer=${transfer}`;
            window.location.href = deleteUrl;
        } catch (error) {
            console.error("Error during user deletion: ", error);
            alert("Failed to process request. Please try again.");

            // Re-enable button on failure
            button.classList.remove('is-disabled', 'is-loading');
        }
    }

    // Event listeners
    deleteUserBtn.addEventListener('click', (e) => {
        e.preventDefault();
        openModal();
    });

    closeBtn.addEventListener('click', closeModal);
    modalBackdrop.addEventListener('click', closeModal);

    deleteEventsBtn.addEventListener('click', () => {
        handleAction('delete', deleteEventsBtn);
    });

    transferEventsBtn.addEventListener('click', () => {
        handleAction('transfer', transferEventsBtn);
    });
});